import React from "react";
import styled from "styled-components";
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

const Title = styled.h2`
  margin: 20px 0px;
`;

const Row = styled.div`
  border-radius: 16px;
  box-shadow: 0 0 33px rgb(137 156 197 / 17%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin: 4px 0px;
  min-width: 400px;
  width: 100%;

  @media(max-width: 620px) {
    min-width: unset;
  }

  p {
    font-size: 1.125rem;
    margin: 0;
  }

  p:nth-child(1) {
    font-weight: bold;
  }

  p:nth-child(2) {
    font-size: 1.25rem;
    color: #86929f;
  }
`;

const DataRow = ({date, value}) => {
  const formatedDate = moment.utc(date).format('MMM Do')

  return (
    <Row>
      <p>{formatedDate}</p>
      <p>{Number(value * 2.204622).toFixed(1)} lbs</p>
    </Row>
  )
}

export const DailyWeightModal = ({open, onClose, data}) => (
  <Dialog
    open={open}
    onClose={() => onClose()}
  >
    {data &&
      <DialogContent className="avn-modal-content-container">
        <Title>Daily weights for {data.date} check-in</Title>
        {data.daily_weights.map((item, id) => {
          return (
            <DataRow
              key={item.weigh_in_date}
              date={item.weigh_in_date}
              value={item.weight}
            />
          )
        })}
      </DialogContent>
    }
    <DialogActions className='avn-modal-actions-container'>
      <button
        className="avn-modal-action"
        onClick={() => onClose()}
      >
        Close
      </button>
    </DialogActions>
  </Dialog>
)

